import React from 'react';

import { Main, MainHeader, Body } from 'components/Main';

import Events from './Events';
import News from './News';
import Highlights from './Highlights';
import Records from './Records';
import Results from './Results';
import Fixtures from './Fixtures';

const HomePage = () => (
    <Main>
        <MainHeader />
        <Body id="home-page">
            <div className="cc-cols-8 cc-cols-responsive">
                <Events />
                <News />
            </div>
            <div className="cc-cols-4 cc-cols-responsive">
                <Highlights />
                <Records />
                <Results />
                <Fixtures />
            </div>
        </Body>
    </Main>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/views/home/HomePage.jsx